
/// 発注ステータス
/// 設定なし''の時、新規作成
export const PURCHASE_STATUS = {
    UNORDERED: '00',
    ORDER_APPROVED: '10',
    ORDERED: '20',
    ORDERED_K: '20K',
    WAITING_DATA: '21K',
    WAITING_REVIEW: '22K',
    WAITING_DELIVERY: '30',
    WAITING_DELIVERY_K: '30K',
    WAITING_INSPECTION: '40',
    WAITING_INSPECTION_K: '40K',
    INSPECTED: '50',
    INSPECTED_K: '50K',
    INSPECTION_APPROVED: '60',
    INVOICED: '70',
    BILLED_CONFIRMED: '80',
} as const

export type PURCHASE_STATUS = typeof PURCHASE_STATUS[keyof typeof PURCHASE_STATUS];

/// 通知種類
export const NOTIFY_TYPE = {
    SMS: 0,
    MAIL: 1,
} as const

export type NOTIFY_TYPE = typeof NOTIFY_TYPE[keyof typeof NOTIFY_TYPE];

/// 軽減税率区分
export const REDUCED_TAX_RATE_TYPE = {
    NORMAL: '0',        //軽減税率対象外
    REDUCED: '1',       //軽減税率対象
} as const

export type REDUCED_TAX_RATE_TYPE = typeof REDUCED_TAX_RATE_TYPE[keyof typeof REDUCED_TAX_RATE_TYPE];

//請求新規登録 ステータス
export const INVOICE_STATUS_CODE = [
    { statusCode: '70', statusName: '請求確定済み' },
];
export type INVOICE_STATUS_CODE = typeof INVOICE_STATUS_CODE[keyof typeof INVOICE_STATUS_CODE];

//請求新規登録
export const OTHER_STATUS_CODE = [
    { orderTypeCode: '91', orderTypeName: 'その他請求' },
];
export type OTHER_STATUS_CODE = typeof OTHER_STATUS_CODE[keyof typeof OTHER_STATUS_CODE];
